import { render, staticRenderFns } from "./up.vue?vue&type=template&id=44036ed8&scoped=true"
import script from "./up.vue?vue&type=script&lang=js"
export * from "./up.vue?vue&type=script&lang=js"
import style0 from "./up.vue?vue&type=style&index=0&id=44036ed8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44036ed8",
  null
  
)

export default component.exports